import { createIcon } from '@chakra-ui/react'

export const ChevronLeftIcon = createIcon({
  displayName: 'ChevronLeftIcon',
  viewBox: '0 0 24 24',
  path: (
    <path d='M15 18L9 12L15 6' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round' fill='none' />
  ),
})
